import ReactDOM from 'react-dom'
import React, { forwardRef, ReactNode, useRef, useState } from 'react'

import { Checkbox } from 'primsell-shared-layer/components'

import * as S from './list-item.styles'

import { CheckboxColorT, CheckboxVariantT } from '../index.types'

export enum ListItemVariantE {
  DEFAULT = 'DEFAULT',
  SMALL = 'SMALL',
}

interface IListItemProps {
  children: ReactNode
  styleVariant?: ListItemVariantE
  isSelected: boolean
  checkboxVariant?: CheckboxVariantT
  checkboxColor?: CheckboxColorT
  onClick?: React.MouseEventHandler<HTMLDivElement>
  enableTooltup?: boolean
}

const ListItem = ({
  children,
  styleVariant = ListItemVariantE.DEFAULT,
  isSelected,
  checkboxVariant,
  checkboxColor,
  onClick,
  enableTooltup,
}: IListItemProps) => {
  const ref = useRef(null)
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 })
  const tooltipRef = useRef(null)
  const portalRoot = document.getElementById('portal-root')

  const handleMouseEnter = () => {
    // @ts-ignore
    if (ref?.current) {
      // @ts-ignore
      const rect = ref.current.getBoundingClientRect()
      setTooltipPosition({
        top: rect.top + window.scrollY - 20,
        left: rect.left + window.scrollX,
      })

      if (tooltipRef && tooltipRef.current) {
        // @ts-ignore
        tooltipRef.current.style.display = 'flex'
      }
    }
  }

  const handleMouseLeave = () => {
    if (tooltipRef && tooltipRef.current) {
      // @ts-ignore
      tooltipRef.current.style.display = 'none'
    }
  }

  const tooltipContent = (
    <div
      ref={tooltipRef}
      style={{
        position: 'absolute',
        width: 'fit-content',
        height: '20px',
        backgroundColor: '#adb5bd',
        display: 'none',
        top: `${tooltipPosition.top}px`,
        left: `${tooltipPosition.left}px`,
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        padding: '12px 8px',
        borderRadius: '4px',
        zIndex: 1050,
        cursor: 'pointer',
        color: 'white',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  )

  return (
    <S.Option
      ref={ref}
      $isSelected={isSelected}
      styleVariant={styleVariant}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ position: 'relative' }}
    >
      {enableTooltup && portalRoot && ReactDOM.createPortal(tooltipContent, portalRoot)}
      {checkboxVariant && <Checkbox checked={isSelected} variant={checkboxVariant} color={checkboxColor} readOnly />}
      <S.Label $isSelected={isSelected}>{children}</S.Label>
    </S.Option>
  )
}

ListItem.displayName = 'ListItem'

export { ListItem }
